import { render } from "./donate.web.vue?vue&type=template&id=871ea4c0&scoped=true"
import script from "./donate.vue.js?vue&type=script&lang=js"
export * from "./donate.vue.js?vue&type=script&lang=js"

import "./donate.web.vue?vue&type=style&index=0&id=871ea4c0&scoped=true&lang=css"

import exportComponent from "D:\\PC-Data\\Code\\jdqus\\public\\webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871ea4c0"],['__file',"src/vue/_components/_site/donate/donate.web.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "871ea4c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('871ea4c0', __exports__)) {
    api.reload('871ea4c0', __exports__)
  }
  
  module.hot.accept("./donate.web.vue?vue&type=template&id=871ea4c0&scoped=true", () => {
    api.rerender('871ea4c0', render)
  })

}


export default __exports__